import React from 'react';

import AutoSizer from 'components/AutoSizer';
import Breadcrumbs from 'ui-library/Breadcrumbs';
import {Header1} from 'ui-library/Headers';
import SettingsIcon from 'ui-library/icons/SettingsIcon';
import ModalAnchor from 'ui-library/ModalAnchor';
import WorkflowSettingsModal from 'workflows/modals/WorkflowSettingsModal';
import WorkflowConfigurationVisualization from 'workflows/visualization/WorkflowConfigurationVisualization';
import {StageConfiguration, StageFlowNode, Workflow} from 'workflows/WorkflowConstants';

import {WorkflowsCrumbLink} from './WorkflowCrumbLinks';
import WorkflowDescription from './WorkflowDescription';

interface WorkflowConfigurationHeaderProps {
  workflow: Workflow;
  stageConfigurations: Array<StageConfiguration>;
  stageConfigurationIdToStageFlowNodes: {[stageConfigurationId: string]: Array<StageFlowNode>};
}

interface State {
  isSettingsModalOpen: boolean;
}

export default class WorkflowConfigurationHeader extends React.Component<
  WorkflowConfigurationHeaderProps,
  State
> {
  override state: State = {
    isSettingsModalOpen: false,
  };

  _handleClickSettingsIcon = (): void => {
    this.setState({
      isSettingsModalOpen: true,
    });
  };

  _handleRequestCloseModal = (): void => {
    this.setState({
      isSettingsModalOpen: false,
    });
  };

  _shouldShowSettings(): boolean {
    return this.props.workflow.permissions.writable;
  }

  override render(): JSX.Element {
    return (
      <div className="workflows-workflowDetailsHeader">
        <div className="workflows-workflowDetailsHeader-column is-expanded">
          <div className="workflows-workflowDetailsHeader-row1" />
          <Breadcrumbs>
            <WorkflowsCrumbLink className="workflows-workflowDetailsHeader-workflowsCrumbLink" />
          </Breadcrumbs>
          <div>
            <ModalAnchor open={this.state.isSettingsModalOpen}>
              <WorkflowSettingsModal
                onRequestClose={this._handleRequestCloseModal}
                workflow={this.props.workflow}
              />
            </ModalAnchor>
            <span className="workflows-workflowHeader-header">
              <Header1 className="workflows-workflowDetailsHeader-workflowHumanId">
                {this.props.workflow.humanId}
              </Header1>
              {this._shouldShowSettings() && <SettingsIcon onClick={this._handleClickSettingsIcon} />}
            </span>
            <div className="workflows-workflowDetailsHeader-workflowName">{this.props.workflow.name}</div>
            <WorkflowDescription
              description={this.props.workflow.description}
              onClickMore={this._handleClickSettingsIcon}
            />
          </div>
        </div>
        <div className="workflows-workflowDetailsHeader-right">
          <AutoSizer disableHeight={true}>
            {({width}) => (
              <div className="workflows-workflowDetailsHeader-workflowVisualizationContainer">
                <WorkflowConfigurationVisualization
                  containerWidth={width}
                  isEditable={this.props.workflow.permissions.writable}
                  stageConfigurations={this.props.stageConfigurations}
                  stageConfigurationIdToStageFlowNodes={this.props.stageConfigurationIdToStageFlowNodes}
                />
              </div>
            )}
          </AutoSizer>
        </div>
      </div>
    );
  }
}
